// @flow

import React from 'react';

const SentAllReminders = ({ translate }: { translate: any }) => (
<div className="sent-all-reminders reminder--padded">
  <h3 className="reminder--orange text-center">{translate('reminder.sent_all')}</h3>
  <span className="text-center">{translate('reminder.each_only_twice')}</span>
</div>
);

export default SentAllReminders;



// WEBPACK FOOTER //
// ./src/components/main/InsuranceInquiry/reminder/sentAllReminders.js